import React, { useEffect, useState } from "react";
import { FxmsData } from "../datas/FxData";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'
import Highcharts from "highcharts";
import { FxImageBoard, FxImageBoardConfig, FxImageBoardContainer, FxImageBoardContainerConfig } from "./FxImageBoard";
import { FxIconButton, FxIconButtonConfig } from "./FxIconButton";
import { FxTextBox, FxTextBoxConfig } from "./FxTextBox";
import { FxContentBox } from "./FxContentBox";
import { FxMenuList } from "./FxMenuList";
import { FxOpButton, FxOpButtonConfig } from "./FxOpButton";
import { FxMap, FxMapContainer, FxMapContainerConfig } from "./map/FxMap";
import { FxRtGuageChart } from "./Gadgets/charts/FxRtGuageChart";
import { FxLineChart } from "./Gadgets/charts/FxLineChart";
import { FxPieChart } from "./Gadgets/charts/FxPieChart";
import { FxLineZoomChart } from "./Gadgets/charts/FxLineZoomChart";
import {FxFlowGojs} from "./Gadgets/charts/FxFlowGojs";
import {FxTPDataGrid} from "./FxTPDataGrid";
import {FxMoListConfig, FxMoListDash} from "./FxMoList";
import {VupDash} from "../../vup/VupDash";
import {PlantDash} from "../../vup/PlantDash";
import {VupComplexDash} from "../../vup/VupComplexDash";
import {VupPlantDash} from "../../vup/VupPlantDash";
import {FxTreeMenu} from "./FxTreeMenu";
import axios from "axios";
import RGL, {WidthProvider} from "react-grid-layout";

import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import IconButton from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import Fab from "@mui/material/Fab";
import {ListItemAvatar} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import FxAppBar from "./FxAppBar";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import {DataGrid} from "./Gadgets/grid/DataGrid";
import {TextBox} from "./Gadgets/box/TextBox";
import {MultilineTextBox} from "./Gadgets/box/MultilineTextBox";
import {FxLiveTimeBox} from "./Gadgets/box/FxLiveTimeBox";
import jwt_decode from "jwt-decode";
import DeleteIcon from "@mui/icons-material/Delete";
import {ErrorBoundary} from "./ErrorBoundary";
import {IndustMap} from "./Gadgets/maps/IndustMap";
import FxBaseChart from "./Gadgets/charts/FxBaseChart";
import {TextBox_CemsDash001} from "./Gadgets/box/TextBox_CemsDash001";
import {CemsNetworkStatus} from "./Gadgets/button/CemsNetworkStatus";
import {CemsEnergyUsageListGrid} from "./Gadgets/button/CemsEnergyUsageListGrid";

const ROWHEIGHT = 10;
const COLS = 128;
const ReactGridLayout = WidthProvider(RGL);

export const GadgetDashboard = (props) => {

    const [layout, setLayout] = useState([]);
    const [editable, setEditable] = useState(props.editable)
    const [uiGrpNo, setUiGrpNo] = useState(props.uiGrpNo)
    const [items, setItems] = useState([{uiNo:0,uiTitle:'FxAppBar'}])
    const [attrs, setAttrs] = useState([])
    const [menu, setMenu] = useState(false)
    const [dashbNo, setDashbNo] = useState(props.dashbNo)
    const [fxUiDashb, setFxUiDashb] = useState({})
    const [gadgets, setGadgets] = useState([
        {opId:'IndustMap',name:'산업지도',desc:'산업지도, 국토부',icon:'fxindusmap.png'},
        {opId:'FxLineChart',name:'라인챠트',desc:'라인챠트(하이챠트)',icon:'linechart.png'},
        {opId:'DataGrid',name:'데이터테이블',desc:'데이터테이블(데이터그리드)',icon:'datagrid.png'},
        {opId:'TextBox',name:'텍스트상자',desc:'텍스트상자(단일라인)',icon:'textbox.png'},
        {opId:'TextBox_CemsDash001',name:'CEMS 텍스트상자1',desc:'CEMS 산단 대시보드 상단 상자 컴포넌트',icon:'textbox.png'},
        {opId:'CemsNetworkStatus',name:'BUTTON_CEMS 네트워크상태 표시',desc:'BUTTON형 컴포넌트 CEMS 산단 대시보드 상단 컴포넌트',icon:'textbox.png'},
        {opId:'CemsEnergyUsageListGrid',name:'BUTTON_CEMS 전력 사용현황 목록',desc:'BUTTON형 컴포넌트 CEMS 산단 대시보드 상단 컴포넌트',icon:'textbox.png'},
        {opId:'MultilineTextBox',name:'멀티라인 텍스트상자',desc:'텍스트상자(멀티라인)',icon:'multilinetextbox.png'},
        {opId:'FxFlowGojs',name:'플로우챠트',desc:'플로우챠트',icon:'flowchart.png'},
        {opId:'FxLiveTimeBox',name:'시계상자',desc:'년월일표시 상자',icon:'livetimebox.png'},
        {opId:'VupDash',name:'VupDash',desc:'대시보드',icon:'vupdash.png'},
        {opId:'PlantDash',name:'PlantDash',desc:'공장대시보드',icon:'vupdash.png'},
        {opId:'VupComplexDash',name:'VupComplexDash',desc:'산단대시보드',icon:'complexdash.png'},
        {opId:'VupPlantDash',name:'VupPlantDash',desc:'공장대시보드',icon:'plantdash.png'},
        {opId:'FxTreeMenu',name:'FxTreeMenu',desc:'FxTreeMenu',icon:''},
        {opId:'FxRtGuageChart',name:'게이지챠',desc:'게이지차트(하이챠트)',icon:'gaugechart.png'},
        {opId:'FxLineZoomChart',name:'라인줌챠트',desc:'라인줌챠트(하이챠트)',icon:'linezoomchart.png'},


    ])
    //관리대상
    const [sensors, setSensors] = useState([])
    //수집항목
    const [psItems, setPsItems] = useState([])
    //가젯들의 정보
    const [gadgetData, setGadgetData] = useState([])
    //사이트 선택
    const [selectedSite, setSelectedSite] = useState('')

    useEffect(()=>{
        initDashboard()
        FxmsData.GET('fxms/mo').then(res=>{
            //inloNo
            //moClass
            //moDispName
            //moNo
            //moName
            //moMemo
            let sensorList = res.data.filter(x=>x.moClass==="SENSOR")
            setSensors(sensorList)
        })
        FxmsData.GET('fxms/psItem').then(res=>{
            //psName
            //psUnit
            //psId
            let psItemList = res.data.filter(x=> x.useYn==="Y")
            setPsItems(psItemList)
        })
    },[])

    const initDashboard = () => {
        FxmsData.GET("fxUiDash/ui/"+props.dashbNo).then(res => {
            let dashList = res.data.fxUiDashbs
            let curDashBoard = dashList.find(x=>x.dashbNo==props.dashbNo)
            let lay = []
            setFxUiDashb(curDashBoard)
            let items = curDashBoard.fxUiDashbItems
            let attrs = curDashBoard.fxUiDashbItemAttrs
            items.map(x=>{
                lay.push({i:x.uiNo,x:x.uiX,y:x.uiY,w:x.uiWidth,h:x.uiHeight})
            })
            setItems(items)
            setLayout(lay)
        })
    }
    const updateHighcharts = () =>{
            for (let i = 0; i < Highcharts.charts.length; i++) {
                if (Highcharts.charts[i] !== undefined) {
                    Highcharts.charts[i].reflow();
                }
            }
        }
    const onLayoutChange = (data) => {
        //save
        setLayout(data)
        updateHighcharts()
        if(data.length > 0){
            items.map(x=>{
                for(let y of data){
                    if(parseInt(y.i) == parseInt(x.uiNo)){
                        x.uiX = y.x
                        x.uiY = y.y
                        x.uiWidth = y.w
                        x.uiHeight = y.h
                    }
                }
            })

            //save layout
            FxmsData.PUT('fxUiDash/ui/items',items).then(res=>{
                console.log(res)
            })
        }

    }

    const addGadget = (id) => {
        let uiNo = 0
        //다음 uiNo 구하기
        for (let item of items) {
            if (item.uiNo > uiNo) {
                uiNo = item.uiNo;
            }
        }
        uiNo++;
        let unit = parseInt(window.innerWidth / COLS);
        setLayout([...layout,{i:uiNo,x:5,y:5,w:2*unit,h:3*ROWHEIGHT}])
        setItems([...items, {dashbNo:dashbNo, uiNo:uiNo,opId:id,uiTitle:'',uiStyle:'',uiX:0,uiY:0,uiWidth:0,uiHeight:0,useYn:"N"}])
        FxmsData.POST('fxUiDash/item',{dashbNo:dashbNo, uiNo:uiNo,opId:id,uiTitle:'',uiStyle:'',uiX:0,uiY:0,uiWidth:0,uiHeight:0,useYn:"N"}).then(res=>{
            console.log(res)
        })

    }
    const makeGadget = (item,lay) =>{
        let dashComp = ''
        let configComp = ''
        // const className = 'FxStyle' + ((editable ? 'Edit' : x.uiStyle));
        if(item.opId === "FxAppBar"){
            dashComp =  <FxAppBar name={item.opId} key={item.uiNo} id={item.uiNo} fxUiGrp={item.dashbNo} fxUiGrpItem={item} />
        }else if(item.opId === "FxOpButton"){
            dashComp =  <FxOpButton name={item.opId} key={item.uiNo} id={item.uiNo} fxUiGrp={item.dashbNo} fxUiGrpItem={item} />
            configComp = FxOpButtonConfig(item.dashbNo,item)
        }else if(item.opId === "FxRtGuageChart"){
            dashComp =  <FxRtGuageChart sensorList={sensors}  psItemList={psItems} editable={editable} save={saveGadgetData} removeItem={removeItem} item={item} />
        }else if(item.opId === "FxLineChart"){
            // dashComp =  <FxLineChart sensorList={sensors}  psItemList={psItems} editable={editable} save={saveGadgetData} removeItem={removeItem}  item={item} />
            dashComp =  <FxBaseChart editable={editable} save={saveGadgetData} removeItem={removeItem}  item={item} />
        }else if(item.opId === "FxPieChart"){
            dashComp =  <FxPieChart sensorList={sensors}  psItemList={psItems} editable={editable} save={saveGadgetData} removeItem={removeItem}  item={item}  />
        }else if(item.opId === "FxLineZoomChart"){
            dashComp =  <FxLineZoomChart sensorList={sensors}  psItemList={psItems} editable={editable} save={saveGadgetData} removeItem={removeItem}  item={item} />
        }else if(item.opId === "FxImageBoard"){
            dashComp =  <FxImageBoard name={item.opId} key={item.uiNo} id={item.uiNo} fxUiGrp={item.dashbNo} fxUiGrpItem={item} />
        }else if(item.opId === "FxContainerBox"){
            dashComp =  <FxImageBoardContainer name={item.opId} key={item.uiNo} id={item.uiNo} fxUiGrp={item.dashbNo} fxUiGrpItem={item} />
        }else if(item.opId === "FxIconButton"){
            dashComp =  <FxIconButton name={item.opId} key={item.uiNo} id={item.uiNo} fxUiGrp={item.dashbNo} fxUiGrpItem={item} />
            configComp = FxIconButtonConfig(item.dashbNo,item)
        }else if(item.opId === "FxMap"){
            dashComp =  <FxMap name={item.opId} key={item.uiNo} id={item.uiNo} fxUiGrp={item.dashbNo} fxUiGrpItem={item} save={saveGadgetData} />
        }else if(item.opId === "FxContentBox"){
            dashComp =  <FxContentBox name={item.opId} key={item.uiNo} id={item.uiNo} fxUiGrp={item.dashbNo} fxUiGrpItem={item} />
        }else if(item.opId === "FxSensorBox"){
            dashComp =  <FxTPDataGrid name={item.opId} key={item.uiNo} id={item.uiNo} fxUiGrp={item.dashbNo} fxUiGrpItem={item} />
        }else if(item.opId === "FxMenuList"){
            dashComp =  <FxMenuList name={item.opId} key={item.uiNo} id={item.uiNo} fxUiGrp={item.dashbNo} fxUiGrpItem={item} />
        }else if(item.opId === "FxTextBox"){
            dashComp =  <FxTextBox name={item.opId} key={item.uiNo} id={item.uiNo} fxUiGrp={item.dashbNo} fxUiGrpItem={item} />
            configComp = FxTextBoxConfig(item.dashbNo,item)
        }else if(item.opId === "FxMoList"){
            dashComp =  <FxMoListDash name={item.opId} key={item.uiNo} id={item.uiNo} fxUiGrp={item.dashbNo} fxUiGrpItem={item} />
            configComp = FxMoListConfig(item.dashbNo,item)
        }else if(item.opId === "FxFlowGojs"){
            dashComp =  <FxFlowGojs sensorList={sensors}  psItemList={psItems} editable={editable} save={saveGadgetData} removeItem={removeItem}  item={item}  />
        }else if(item.opId === "VupDash"){
            dashComp =  <VupDash name={item.opId} key={item.uiNo} id={item.uiNo} fxUiGrp={item.dashbNo} fxUiGrpItem={item} />
        }else if(item.opId === "PlantDash"){
            dashComp =  <PlantDash name={item.opId} key={item.uiNo} id={item.uiNo} fxUiGrp={item.dashbNo} fxUiGrpItem={item} />
        }else if(item.opId === "VupComplexDash"){
            dashComp =  <VupComplexDash name={item.opId} key={item.uiNo} id={item.uiNo} fxUiGrp={item.dashbNo} fxUiGrpItem={item} />
        }else if(item.opId === "VupPlantDash"){
            dashComp =  <VupPlantDash name={item.opId} key={item.uiNo} id={item.uiNo} fxUiGrp={item.dashbNo} fxUiGrpItem={item} />
        }else if(item.opId === "DataGrid"){
            dashComp =  <DataGrid editable={editable} save={saveGadgetData} item={item} removeItem={removeItem} />
        }else if(item.opId === "TextBox"){
            dashComp =  <TextBox editable={editable} save={saveGadgetData} item={item} removeItem={removeItem} />
        }else if(item.opId === "MultilineTextBox"){
            dashComp =  <MultilineTextBox editable={editable} save={saveGadgetData} item={item} removeItem={removeItem}/>
        }else if(item.opId === "FxLiveTimeBox"){
            dashComp = <FxLiveTimeBox editable={editable} save={saveGadgetData} item={item} removeItem={removeItem} />
        }else if(item.opId === "FxTreeMenu"){
            dashComp = <FxTreeMenu />
        }else if(item.opId === "IndustMap"){
            dashComp = <IndustMap lock={setEditable} editable={editable} save={saveGadgetData} item={item} selectedSite={setSelectedSite} />
        }else if(item.opId === "TextBox_CemsDash001"){
            dashComp = <TextBox_CemsDash001 editable={editable} save={saveGadgetData} item={item} selectedSite={setSelectedSite} />
        }else if(item.opId === "CemsNetworkStatus"){
            dashComp = <CemsNetworkStatus editable={editable} save={saveGadgetData} item={item} selectedSite={setSelectedSite} />
        }else if(item.opId === "CemsEnergyUsageListGrid"){
            dashComp = <CemsEnergyUsageListGrid editable={editable} save={saveGadgetData} item={item} selectedSite={setSelectedSite} />
        }else{
            dashComp =  <div>{item.opId} Not Found</div>
        }
        return dashComp
    }
    const removeItem = (uiNo) => {
        //remove from layout
        let removed = layout.filter(x=> x.i != uiNo)
        setLayout(removed)
        //remove from items and attrs
        FxmsData.PUT('fxUiDash/ui/DashbItemDel',{
            dashbNo:dashbNo,uiNo:uiNo
        })
    }
    const saveGadgetData = (attr,uiNo,opId) => {

        attr.map(x=>{
            x.dashbNo = dashbNo
        })
        //편집한 레이아웃(아이템)
        let findItemLayout = layout.find(x=>x.i == uiNo)
        findItemLayout.dashbNo = dashbNo
        findItemLayout.uiNo = uiNo
        findItemLayout.opId = opId
        findItemLayout.uiTitle = ''
        findItemLayout.uiStyle = ''
        findItemLayout.useYn = 'Y'
        findItemLayout.sortSeq = '1'
        findItemLayout.regUserNo = FxmsData.getUserNo()
        findItemLayout.uiX = findItemLayout.x
        findItemLayout.uiY = findItemLayout.y
        findItemLayout.uiWidth = findItemLayout.w
        findItemLayout.uiHeight = findItemLayout.h
        findItemLayout.fxUiDashbItemAttrs = attr


        FxmsData.PUT('fxUiDash/ui/item',findItemLayout).then(res=>{
            console.log(res)
        })

    }


    return (
        <>
            <ReactGridLayout
                onLayoutChange={onLayoutChange}
                onDragStop={onLayoutChange}
                className="FxDashBoardLayout"
                rowHeight={10}
                cols={128}
                allowOverlap={true}
                compactType={null}
                margin={[0,0]}
            >
                {
                    layout.map(l=>{
                        let item = items.find(x=>x.uiNo == l.i)
                        if(!editable){
                            l.static = true
                        }else{
                            l.static = false
                        }
                        return (
                        <div key={l.i} data-grid={l} >
                            {!l.static ? <IconButton size={'small'} sx={{minWidth:0, right:'5px',position:'absolute',zIndex:999}} onClick={()=>{removeItem(l.i)}}>
                                <DeleteIcon/>
                            </IconButton> : ''}
                            <ErrorBoundary gadget={item.opId}>
                                {makeGadget(item,l)}
                            </ErrorBoundary>

                        </div>
                        )
                    })

                }
            </ReactGridLayout>
            <Drawer
                sx={{width: "500px", flexShrink: 0,
                    '& .MuiDrawer-paper': {width: "500px", boxSizing: 'border-box',backgroundColor:'#ababab'},
                }}
                variant="persistent"
                anchor={'right'}
                open={menu}
                onClose={()=>setMenu(false)}
            >
                <IconButton onClick={()=>setMenu(false)}>
                    <ChevronRightIcon />
                </IconButton>
                <FormControlLabel style={{float:'right',margin:'3px'}} control={<Switch onChange={()=>setEditable(!editable)} defaultChecked />} label="편집모드" />
                <List sx={{ width: '100%' }}>
                    {gadgets.map(x=>{
                    return(
                        <>
                            <ListItem alignItems="flex-start" key={x.id}>
                                <ListItemAvatar>
                                    <Avatar sx={{width:'64px',right:'10px'}} variant="square" alt={x.icon} src={x.icon} />
                                    <Button onClick={()=>addGadget(x.opId)} style={{width:'55px',right:'10px'}} variant="contained" size="small" color="primary">ADD</Button>
                                </ListItemAvatar>
                                <ListItemText primary={x.name}
                                    secondary={<Typography sx={{ display: 'inline' }} component="span" variant="body2" color="text.primary">{x.desc}</Typography>}/>
                            </ListItem>
                            <Divider variant="inset" component="li" />
                        </>
                    )
                    })}
                </List>
            </Drawer>
            {menu?'':
                jwt_decode(localStorage.getItem("token")).userNo === 2 ?
                <Fab className="" style={{top:'40px',right:'40px',position:'absolute'}} color="primary" variant="extended" onClick={()=>setMenu(true)}>
                    <EditIcon  sx={{ mr: 1 }}/>
                    ADD gadgets
                </Fab> : ''}
        </>



    )
}